/**
 * Constants for the product variation display types.
 */
const DisplayTypes = {
  List: 1,
  ImageAndLabel: 2,
  ImageOnly: 3,
  Tile: 4,
};

export default DisplayTypes;
